import React from 'react';
import { PortknoxPlans } from '@portknox_net/portknox-prices';
import { Container } from 'semantic-ui-react';
import { MODE_WEBSITE } from '../../consts';
import { defineMessages, useIntl } from 'react-intl';
import Helmet from '@plone/volto/helpers/Helmet/Helmet';
import { createPortal } from 'react-dom';
import Icon from '@plone/volto/components/theme/Icon/Icon';

import Toolbar from '@plone/volto/components/manage/Toolbar/Toolbar';
import { useClient } from '@plone/volto/hooks/client/useClient';
import { getBaseUrl } from '@plone/volto/helpers/Url/Url';
import backSVG from '@plone/volto/icons/back.svg';
import { Link, useLocation } from 'react-router-dom';

const messages = defineMessages({
  portknoxPrices: {
    id: 'Prices',
    defaultMessage: 'Pricing and Plans - Portknox Nextcloud Hosting',
  },
  portknoxPrices_title: {
    id: 'cloud-plans',
    defaultMessage: 'Cloud plans',
  },
  portknoxPrices_desc: {
    id: 'cloud-plans-desc',
    defaultMessage:
      'Portknox grows with you – based on your needs. Start with the right cloud plan and scale it flexibly whenever you need more.',
  },

  seo_description: {
    id: 'SEO Description Prices',
    defaultMessage:
      'Here you will find an overview of the fees for the different versions of Portknox Hosting as well as an overview of the features included.',
  },
  back: {
    id: 'Back',
    defaultMessage: 'Back',
  },
});

const PricesView = (props) => {
  const intl = useIntl();
  const isClient = useClient();
  const { pathname } = useLocation();
  // Workaround for env not in process env on prodution build
  let PAYPAL_CLIENT_ID = process.env.RAZZLE_PAYPAL_CLIENT_ID;
  if (__CLIENT__) {
    PAYPAL_CLIENT_ID = window.env.RAZZLE_PAYPAL_CLIENT_ID;
  }
  return (
    <Container id="portknox-prices">
      <Helmet
        title={intl.formatMessage(messages.portknoxPrices)}
        meta={[
          {
            name: 'description',
            content: intl.formatMessage(messages.seo_description),
          },
        ]}
      />
      <h1 className="documentFirstHeading">
        {intl.formatMessage(messages.portknoxPrices_title)}
      </h1>
      <p>{intl.formatMessage(messages.portknoxPrices_desc)}</p>
      <br />
      <br />

      <PortknoxPlans
        mode={MODE_WEBSITE}
        paypalClientId={PAYPAL_CLIENT_ID}
        lang={intl.locale}
      />

      {isClient &&
        createPortal(
          <Toolbar
            pathname={pathname}
            hideDefaultViewButtons
            inner={
              <Link to={`${getBaseUrl(pathname)}`} className="item">
                <Icon
                  name={backSVG}
                  className="contents circled"
                  size="30px"
                  title={intl.formatMessage(messages.back)}
                />
              </Link>
            }
          />,
          document.getElementById('toolbar'),
        )}
    </Container>
  );
};

export default PricesView;
